/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PartnerData } from './PartnerData';
import {
    PartnerDataFromJSON,
    PartnerDataFromJSONTyped,
    PartnerDataToJSON,
} from './PartnerData';
import type { VehicleCategoryData } from './VehicleCategoryData';
import {
    VehicleCategoryDataFromJSON,
    VehicleCategoryDataFromJSONTyped,
    VehicleCategoryDataToJSON,
} from './VehicleCategoryData';

/**
 * 
 * @export
 * @interface PreBookingConfigDto
 */
export interface PreBookingConfigDto {
    /**
     * 
     * @type {number}
     * @memberof PreBookingConfigDto
     */
    maxBookingDays: number;
    /**
     * 
     * @type {number}
     * @memberof PreBookingConfigDto
     */
    earliestPrebookingPossibleIn: number;
    /**
     * 
     * @type {number}
     * @memberof PreBookingConfigDto
     */
    latestPrebookingPossibleIn: number;
    /**
     * 
     * @type {string}
     * @memberof PreBookingConfigDto
     */
    defaultVehicleCategory: string;
    /**
     * 
     * @type {Array<VehicleCategoryData>}
     * @memberof PreBookingConfigDto
     */
    vehicleCategoryData: Array<VehicleCategoryData>;
    /**
     * 
     * @type {number}
     * @memberof PreBookingConfigDto
     */
    cancellationNoFeeTimeoutHours: number;
    /**
     * 
     * @type {boolean}
     * @memberof PreBookingConfigDto
     */
    isDevelopment?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PreBookingConfigDto
     */
    driverNotValidatedTimeout?: number;
    /**
     * 
     * @type {PartnerData}
     * @memberof PreBookingConfigDto
     */
    partner?: PartnerData;
}

/**
 * Check if a given object implements the PreBookingConfigDto interface.
 */
export function instanceOfPreBookingConfigDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "maxBookingDays" in value;
    isInstance = isInstance && "earliestPrebookingPossibleIn" in value;
    isInstance = isInstance && "latestPrebookingPossibleIn" in value;
    isInstance = isInstance && "defaultVehicleCategory" in value;
    isInstance = isInstance && "vehicleCategoryData" in value;
    isInstance = isInstance && "cancellationNoFeeTimeoutHours" in value;

    return isInstance;
}

export function PreBookingConfigDtoFromJSON(json: any): PreBookingConfigDto {
    return PreBookingConfigDtoFromJSONTyped(json, false);
}

export function PreBookingConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreBookingConfigDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'maxBookingDays': json['maxBookingDays'],
        'earliestPrebookingPossibleIn': json['earliestPrebookingPossibleIn'],
        'latestPrebookingPossibleIn': json['latestPrebookingPossibleIn'],
        'defaultVehicleCategory': json['defaultVehicleCategory'],
        'vehicleCategoryData': ((json['vehicleCategoryData'] as Array<any>).map(VehicleCategoryDataFromJSON)),
        'cancellationNoFeeTimeoutHours': json['cancellationNoFeeTimeoutHours'],
        'isDevelopment': !exists(json, 'isDevelopment') ? undefined : json['isDevelopment'],
        'driverNotValidatedTimeout': !exists(json, 'driverNotValidatedTimeout') ? undefined : json['driverNotValidatedTimeout'],
        'partner': !exists(json, 'partner') ? undefined : PartnerDataFromJSON(json['partner']),
    };
}

export function PreBookingConfigDtoToJSON(value?: PreBookingConfigDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'maxBookingDays': value.maxBookingDays,
        'earliestPrebookingPossibleIn': value.earliestPrebookingPossibleIn,
        'latestPrebookingPossibleIn': value.latestPrebookingPossibleIn,
        'defaultVehicleCategory': value.defaultVehicleCategory,
        'vehicleCategoryData': ((value.vehicleCategoryData as Array<any>).map(VehicleCategoryDataToJSON)),
        'cancellationNoFeeTimeoutHours': value.cancellationNoFeeTimeoutHours,
        'isDevelopment': value.isDevelopment,
        'driverNotValidatedTimeout': value.driverNotValidatedTimeout,
        'partner': PartnerDataToJSON(value.partner),
    };
}

